var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86445",
    "data-name": "Group 86445",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.935,
    height: 23.035,
    viewBox: "0 0 22.935 23.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25144",
    "data-name": "Rectangle 25144",
    width: 22.935,
    height: 23.035,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86445-2",
    "data-name": "Group 86445",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242620",
    "data-name": "Path 242620",
    d: "M129.958,93.176a1.14,1.14,0,0,0-1.612,1.612l3.455,3.455a1.113,1.113,0,0,0,1.612,0l8.062-9.214a1.112,1.112,0,0,0-.23-1.612,1.077,1.077,0,0,0-1.5.115l-7.141,8.177Z",
    transform: "translate(-121.09 -82.465)",
    fill: "#02bc7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242621",
    "data-name": "Path 242621",
    d: "M21.883,10.366a1.088,1.088,0,0,0-1.152,1.152,9.214,9.214,0,1,1-18.428,0,9.059,9.059,0,0,1,2.649-6.45A8.786,8.786,0,0,1,11.518,2.3a14.114,14.114,0,0,1,2.188.23,1.169,1.169,0,0,0,1.5-.806c.23-.691-.23-1.152-.806-1.382h-.115A11.358,11.358,0,0,0,11.518,0,11.565,11.565,0,0,0,3.34,19.7a11.33,11.33,0,0,0,8.062,3.34A11.551,11.551,0,0,0,22.92,11.518a1,1,0,0,0-1.037-1.152",
    fill: "#8f8e8d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulations);
export default __webpack_public_path__ + "static/media/Congratulations.03d196d352648a1b437f7dae1ca27e1c.svg";
export { ForwardRef as ReactComponent };